import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Requests aborted by React unmount / route change / user navigation
    // manifest as "Network Error" or CanceledError. Silence them entirely
    // so they don't surface as red overlays or noisy toasts.
    const code = err?.code || "";
    const name = err?.name || "";
    const msg = err?.message || "";
    const isAborted =
      name === "CanceledError" || name === "AbortError" ||
      code === "ERR_CANCELED" || code === "ERR_ABORTED" || code === "ECONNABORTED" ||
      (code === "ERR_NETWORK" && !err?.response) ||
      msg === "Network Error";
    if (isAborted) {
      err.isSilent = true;
      return Promise.reject(err);
    }
    if (err.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

export default api;
